var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.048 10.981a.729.729 0 01-.727.732H4.47l4.349 4.377a.729.729 0 010 1.03.717.717 0 01-1.023 0l-5.583-5.621a.728.728 0 010-1.03l5.583-5.62a.717.717 0 01.515-.214.729.729 0 01.514 1.243l-4.35 4.378h15.858c.39 0 .715.32.715.725z",
    fill: "#444"
  })));
}
export default SvgBackarrow;